<!-- 中间bufen -->
<template>
    <div class='bg box box_between'>
        <div class="numberbg box_f1">
            <div class="title1">银行</div>
            <div class="subtitle1" v-if="bankCount">{{bankCount}}<span style="font-size:13px">家</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title1">银行代理人</div>
            <div class="subtitle1" v-if="bankAgentCount">{{bankAgentCount}}<span style="font-size:13px">人</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title">开发商</div>
            <div class="subtitle"  v-if="developCount">{{developCount}}<span style="font-size:13px">家</span></div>
        </div>
        <div class="numberbg box_f1">
            <div class="title">开发商代理人</div>
            <div class="subtitle">
                <div class="subtitle" v-if="developAgentCount">{{developAgentCount}}<span style="font-size:13px">人</span></div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            bankCount:0,
            bankAgentCount:0,
            developCount:0,
            developAgentCount:0,
            communityIds:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                    this.getData(this.communityIds)
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {
        getData(communityId){
            this.$get(this.urlobj.estateOverView,{
                communityId:communityId
            }).then(res=>{
                this.bankCount = res.newPrimaryKeys.bankCount.toLocaleString()
                this.bankAgentCount = res.newPrimaryKeys.bankAgentCount.toLocaleString()
                this.developCount = res.newPrimaryKeys.developCount.toLocaleString()
                this.developAgentCount = res.newPrimaryKeys.developAgentCount.toLocaleString()
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData(this.communityIds)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/estate/middle1.png');
    background-size: 100% 100%;
    height:120px;
    align-items: center;
    padding:0 10px;
}
.numberbg{
            margin:0 10px;
            width:100%;
            height:88px;
            background-image: url('../../../../assets/images/monitorpy/numberbg.png');
            background-size: 100% 100%;
            
        }
        .title1{
            font-size: 16px;
            color: #01C3FF;
            line-height: 45px;
            text-align: center;
        }
        .subtitle1{
            font-size: 26px;
            font-style: italic;
            color: #09D4FF;
            text-align: center;
            background: linear-gradient(180deg, #00F6FF 0%, #0290FE 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

        }
        .title{
            font-size: 16px;
            color: #00EFE1;
            line-height: 45px;
            text-align: center;
        }
        .subtitle{
            font-size: 26px;
            font-style: italic;
            color: #09D4FF;
            text-align: center;
            background: linear-gradient(180deg, #00FFCC 0%, #00EAFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

        }
</style>